
import { Component, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, SelectItem, MessagesModule } from 'primeng/primeng';
import { Router, ActivatedRoute, Params, Data } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../api.service';
import { StoreService } from '../store.service';
@Component({
  selector: 'app-rah-setting',
  templateUrl: './rah-setting.component.html',
  styleUrls: ['./rah-setting.component.css'],
  providers: [ApiService],
  encapsulation: ViewEncapsulation.None
})
export class RahSettingComponent implements OnInit {

  public rahform: FormGroup;
  public loading: boolean;
  public msgs: Message[] = [];
  loadingMessage: string = "Please wait...";
  companyFiles: any = [];
  qboCompanyFiles: any = [];

  constructor(private fb: FormBuilder, private router: Router, private spinner: NgxSpinnerService,
    private api: ApiService, private ss: StoreService) {

    this.rahform = this.fb.group({
      Title: ["", Validators.required],
      FilePath: ["", Validators.required],
      FilePathCombo: ["", Validators.required],
      UserName: ["", Validators.required],
      Password: ["", Validators.required],
      ConfirmPassword: ["", Validators.required]

    });

  }

  ngOnInit() {

    this.syncCompany();
  }

  getRahDetail() {
    this.msgs = [];


    var accountID = this.ss.fetchAccountID();

    this.api.get('Rah/GetRahByID?accountID=' + 0, '').subscribe(
      (res: {}) => this.sucessGetRah(res),
      error => this.failedGetRah(<any>error));
  }
  syncCompany() {
    this.spinner.show();
    this.api.post('Rah/RahSyncAllCompanyFile', "").subscribe(
      (res: {}) => this.successSyncCompanyFiles(res),
      error => this.failedSyncCompany(<any>error));
  }
  successSyncCompanyFiles(res) {
    if (res.Data != null) {
      this.companyFiles = res.Data.availableFiles;

      if (this.companyFiles == null) return;

      // this.companyFiles.forEach(element => {
      //   this.qboCompanyFiles.push({ label: element.fileName, value: element.filePath });
      // });
      this.companyFiles.forEach(element => {
        if (!element.filePath.toLowerCase().includes('\\upload\\')) {
          this.qboCompanyFiles.push({
            label: element.fileName,
            value: element.filePath
          });
        }
      });
    }
    this.getRahDetail();
  }
  sucessGetRah(resp: any) {

    if (resp.Data != null) {
      var selectedCompanyFile = this.companyFiles.filter(xx => xx.filePath == resp.Data.FilePath);
      var SelectedFileName = "";
      if (selectedCompanyFile != null)
        SelectedFileName = selectedCompanyFile.fileName;
      this.rahform = this.fb.group({
        Title: [resp.Data.Title],
        FilePath: [resp.Data.FilePath],
        FilePathCombo: [resp.Data.FilePath],
        UserName: [resp.Data.UserName],
        Password: [resp.Data.Password],
        ConfirmPassword: [resp.Data.ConfirmPassword]

      });

    }
    this.spinner.hide();
  }
  onChangeCompany(event: any) {
    console.log(event.value);
    this.rahform.controls.FilePath.setValue(event.value);

  }
  failedGetRah(resp: any) {
    console.log(resp);
    this.spinner.hide();
  }

  onSubmit(value: any) {

    this.msgs = [];
    if (this.rahform.valid) {
      if (this.rahform.value.Password != this.rahform.value.ConfirmPassword) {
        this.msgs.push({ severity: 'warn', summary: 'Confirm Password', detail: 'Password does not match.' });
        return;
      }

      this.loading = true;
      this.spinner.show();

      this.api.post('Rah/SaveToken', value).subscribe(
        (res: {}) => this.validateSave(res),
        error => this.validateError(<any>error));

      //this.getRahDetail();

    }
  }

  validateSave(res: any) {
    this.msgs = [];
    this.loading = true;
    this.spinner.show();
    if (res.StatusCode == 0) {
      this.api.post('Rah/SyncCompany', "").subscribe(
        (res: {}) => this.validateCompany(res),
        error => this.validateError(<any>error));
    }
  }

  validateCompany(rah: any) {
    this.msgs = [];
    this.loading = false;
    this.spinner.hide();
    console.log('rah: any');
    console.log(rah);
    if (rah.Success == true) {

      this.api.post('Rah/IsRahVerified', "").subscribe(
        (res: {}) => this.validateIsValid(res),
        error => this.validateError(<any>error));
    }
    else {
      this.loading = false;
      this.spinner.hide();
      this.msgs.push({ severity: 'error', summary: 'please make sure you have entered', detail: "We are not able to connect to your RAH company" });
    }
  }

  validateIsValid(res: any) {
    if (res.StatusCode == 0) {
      var token = this.ss.fetchToken();
      this.router.navigate(['/initlogin/' + token.toString() + '/0/login']);

      //  this.api.post('Rah/SyncAllCustomer', "").subscribe(
      //   (res: {}) => this.validateError(res),
      //   error => this.validateError(<any>error));

      //   this.api.post('Rah/SyncAllItem', "").subscribe(
      //     (res: {}) => this.validateError(res),
      //     error => this.validateError(<any>error));


      //  this.msgs.push({ severity: 'info', summary: 'Success..', detail: "Company connected successfully." });
      //   this.router.navigate(['/docupload']);

    }

  }

  validateError(res: any) {
    this.loading = false;
    this.spinner.hide();

  }
  failedSyncCompany(res: any) {
    this.loading = false;
    this.spinner.hide();
    this.msgs.push({ severity: 'error', summary: 'Failed To Sync Company', detail: "We are not able to connect Please Reconnect your company from switch company menu" });

  }

}
